import { getI18n } from "react-i18next";

export const buildGetTradePendingParams = (
    tradePending: {
        balance?: number;
        body?: string;
        doors?: string;
        drivetrain?: string;
        engine?: string;
        fuel_type?: string;
        isLoading?: boolean;
        make?: string;
        model?: string;
        trim?: string;
        year?: number | string;
    },
    selectName: string,
    selectValue: string,
    partnerId: string
) => {
    let params = "";
    const paramArray = ["make", "model", "trim", "year", "body", "engine", "fuel_type", "doors", "drivetrain"];

    paramArray.forEach((value, index) => {
        if (tradePending.hasOwnProperty(value)) {
            params += `${index !== 0 ? "&" : ""}${value}=${tradePending[value]}`;
        }
    });

    if (selectName && selectValue) {
        params += `&${selectName}=${selectValue}`;
    }

    params += `&partner_id=${partnerId}`;

    return params;
};

export const selectQuestion = (select: string) => {
    const i18n = getI18n();

    switch (select) {
        case "body":
            return i18n.t("TradePending.questions.body");
        case "doors":
            return i18n.t("TradePending.questions.doors");
        case "drivetrain":
            return i18n.t("TradePending.questions.drivetrain");
        case "engine":
            return i18n.t("TradePending.questions.engine");
        case "fuel_type":
            return i18n.t("TradePending.questions.fuelType");
        default:
            return i18n.t("TradePending.questions.oops");
    }
};
